import { TypeKeys, ActionTypes } from '../actions/index';
import { swApi } from '../global/app';
import { convertHydratedWorkoutIntoCustomWorkout } from '../global/workout-utils';
import { CustomWorkout, ExerciseWithOptions, WorkoutObject } from '@sworkit/api';

const getInitialState = (): CustomWorkout => {
  return {
    category: 'strength',
    description: null,
    name: null,
    workout: [],
    exercisesWithOptions: [],
    timingStyle: 'standard',
    deleted: false,
    allowRestBreaks: true,
    allowShuffle: true,
    allowWarmup: true,
  };
};

const editWorkout = (
  state = getInitialState(),
  action: ActionTypes
): CustomWorkout => {
  switch (action.type) {
    case TypeKeys.RESET_EDIT_WORKOUT_STATE: {
      return getInitialState();
    }
    case TypeKeys.SET_EDIT_WORKOUT: {
      const editWorkout = action.editWorkout;
      return {
        ...state,
        ...editWorkout,
      };
    }
    case TypeKeys.SET_EDIT_WORKOUT_CATEGORY: {
      const category = action.category;
      let timingStyle = state.timingStyle;
      if (category === 'yoga') {
        timingStyle = 'yoga';
      }
      if (timingStyle === 'yoga' && category !== 'yoga') {
        timingStyle = 'standard';
      }
      return {
        ...state,
        timingStyle,
        category,
        ...swApi.getAllowancesFromCategory(category),
      };
    }
    case TypeKeys.EDIT_WORKOUT_ADD_EXERCISES: {
      let advancedTiming = false;
      const advancedTimingExercises = state.exercisesWithOptions.filter(
        (exercise) => exercise.timing !== 'default'
      );
      if (advancedTimingExercises.length > 0) {
        advancedTiming = true;
      }
      const slugs = action.slugs;

      const addExercisesWithOptions: ExerciseWithOptions[] = slugs.map(
        (slug) => {
          const exerciseWithOptions: ExerciseWithOptions = {
            timing: 'default',
            slug,
          };
          if (advancedTiming) {
            exerciseWithOptions.timing = 'time';
            exerciseWithOptions.exerciseLength = 30;
          }
          return exerciseWithOptions;
        }
      );
      const exercisesWithOptions = [
        ...state.exercisesWithOptions,
        ...addExercisesWithOptions,
      ];
      return {
        ...state,
        workout: exercisesWithOptions.map((exercise) => exercise.slug),
        exercisesWithOptions,
      };
    }
    case TypeKeys.EDIT_HYDRATED_WORKOUT: {
      const workout = action.workout;
      console.debug('edit workout', workout);
      const editWorkout = convertHydratedWorkoutIntoCustomWorkout(workout as WorkoutObject);
      return {
        ...state,
        ...editWorkout,
      };
    }
    case TypeKeys.REMOVE_EDIT_WORKOUT_EXERCISE: {
      return {
        ...state,
        workout: [
          ...state.workout.slice(0, action.index),
          ...state.workout.slice(action.index + 1),
        ],
        exercisesWithOptions: [
          ...state.exercisesWithOptions.slice(0, action.index),
          ...state.exercisesWithOptions.slice(action.index + 1),
        ],
      };
    }
    case TypeKeys.SET_EDIT_WORKOUT_ADVANCED_TIMING: {
      let exercisesWithOptions = state.exercisesWithOptions;
      if (action.advancedTiming) {
        exercisesWithOptions = exercisesWithOptions.map((exercise) => {
          const exerciseWithOptions: ExerciseWithOptions = {
            timing: 'time',
            slug: exercise.slug,
            exerciseLength: 30,
          };
          return exerciseWithOptions;
        });
      } else {
        exercisesWithOptions = exercisesWithOptions.map((exercise) => {
          const exerciseWithOptions: ExerciseWithOptions = {
            timing: 'default',
            slug: exercise.slug,
          };
          return exerciseWithOptions;
        });
      }
      return {
        ...state,
        exercisesWithOptions,
      };
    }
    case TypeKeys.SET_EDIT_WORKOUT_ADVANCED_TIMING_AT_INDEX: {
      const exercisesWithOptions = state.exercisesWithOptions;
      const timing = action.exerciseWithOptions.timing;
      const index = action.index;
      const updatedExercise: ExerciseWithOptions = {
        slug: exercisesWithOptions[index].slug,
        timing,
      };
      if (timing === 'rep') {
        updatedExercise.repCount = action.exerciseWithOptions.repCount;
      }
      if (timing === 'time') {
        updatedExercise.exerciseLength =
          action.exerciseWithOptions.exerciseLength;
      }
      exercisesWithOptions[action.index] = updatedExercise;
      return {
        ...state,
        exercisesWithOptions,
      };
    }
  }
  return state;
};

export default editWorkout;
